'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./$.classof')
  , test    = {};
test[require('./$.wks')('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  require('./$.redefine')(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/es6.object.to-string.js
 ** module id = 481
 ** module chunks = 0
 **/